import { from as observableFrom, Observable, switchMap, tap, catchError, of } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { buildingCommand } from '../../command/building.command';
import { BuildingService } from '../data/building.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MoveBuildingToPropertyDialogComponent } from '../../component/move-building-to-property-dialog/move-building-to-property-dialog.component';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class MoveToPropertyCommandHandler implements ICommandHandler {
  constructor(
    private _navigationService: NavigationService,
    private _buildingService: BuildingService,
    private _dialogService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === buildingCommand.moveToProperty && command.context;
    }
    return false;
  }
  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._dialogService.open(MoveBuildingToPropertyDialogComponent, this._injector, null, command.context).pipe(
        tap(res => {
          if (res) this._navigationService.reloadCurrentRoute();
        })
      );
    }
  }
}
